import React, { useEffect, useState } from "react";
import { Col, FloatingLabel, Form, Row, Spinner } from "react-bootstrap";
import GeneratePayment from "./GeneratePayment";
import { useFormik } from "formik";
import {
  enterprisePlanSchema,
  noPaymentEnterprisePlanSchema,
} from "validation-schema/enterprise-plan";
import PhoneInput from "react-phone-number-input";
import {
  useCreateEnterpriseSubForExistingUserMutation,
  useCreateEnterpriseSubMutation,
  useCreatExistingEnterprisePlanMutation,
  useGenerateEnterprisePaymentMutation,
  useGetEnterprisePaymentDetailsQuery,
  useGetPlansQuery,
} from "api/enterprisePlanApi";
import {
  ExternalResponse,
  GetPaymentDetailsQuery,
  UserModel,
} from "model/enterprise-plan-model";
import {
  showToastError,
  showToastSuccess,
} from "components/toastify/ToastNotifications";
import { BiChevronLeft } from "react-icons/bi";
import { NumericFormat } from "react-number-format";
import { Countries } from "model/countries-model";
import { useGetCountriesQuery } from "api/countryApi";
import { retrieveUserData } from "redux/authSlice";

type Props = {
  handleReturn: () => void;
};

const CreateEnterpriseWithoutPayment = ({ handleReturn }: Props) => {
  const userId = retrieveUserData()?.userId;
  const [loading, setLoading] = useState<string | null>(null);
  const [activeRuleStep, setActiveRuleStep] = useState("first");
  const [show, setShow] = React.useState(false);
  const [validatedPayment, setValidatedPayment] = React.useState(false);
  const [validatedUser, setValidatedUser] = React.useState(false);
  const [showUserDetails, setShowUserDetails] = React.useState(false);

  const [phoneValidation, setPhoneValidation] = React.useState(false);
  const [phoneNumber, setPhoneNumber] = React.useState<any>();
  const [companyEmail, setCompanyEmail] = React.useState<any>();

  const [application, setApplication] = React.useState<string | null>("Joble");

  const { data: getPlanId } = useGetPlansQuery(
    { application: application },
    { skip: application == null }
  );
  const [createEnterprisePlan] = useCreateEnterpriseSubMutation();
  const [creatExistingEnterprisePlan] =
    useCreatExistingEnterprisePlanMutation();
  const [createEnterpriseForExistingUser] =
    useCreateEnterpriseSubForExistingUserMutation();
  const [generatePaymentLink] = useGenerateEnterprisePaymentMutation();

  const generateLink = async (values: any) => {
    try {
      const model = {
        companyEmail: values?.adminEmail,
        companyName: values?.companyName,
        amount: 0.5,
        frequency: values?.frequency,
        application: "Joble",
        currency: "USD",
        PaymentStatus: 1,
        NoOfUser: values?.maxNumberofUser || 10,
        phoneNumber: values?.phoneNumber,
        personalEmail: values?.personalEmail,
        isExistingUser: false,
        EnterprizeFreePlan: true,
      };
      const result = await generatePaymentLink(model).unwrap();

      if (result?.ResponseCode == "200") {
        showToastSuccess(result?.ResponseMessage);
        setPhoneNumber("");
        completeProcess(values);
      } else {
        showToastSuccess(result?.ResponseMessage);
      }
    } catch (error: any) {
      const response = error.data as ExternalResponse<null>;
      showToastError(response?.ResponseMessage || "");
    } finally {
    }
  };

  const Formik = useFormik({
    validationSchema: noPaymentEnterprisePlanSchema,
    initialValues: {
      application: "Joble",
      subdomain: "",
      provider: "",
      frequency: "",
      activateOn: "",
      expiresOn: "",
      logo: "",
      companyName: "",
      adminFirstname: "",
      adminLastname: "",
      adminEmail: "",
      personalEmail: "",
      companyType: "",
      country: "",
      phoneNumber: "",
      maxNumberofUser: 10,
      storageInGigaByte: 0,
      communicationHistoryInMonth: 0,
      projectLimit: 0,
      dataRetentionPeriodInMonth: 0,
      isNumberOfUserUnlimited: false,
      isStorageUnlimited: false,
      keepCommunicationForever: false,
      keepProjectCreationForever: false,
      timeSheetManagement: false,
      keepDataRetentionForever: false,
      aiAssistance: false,
      unlimitedActivityLog: false,
    },
    onSubmit: async (values) => {
      generateLink(values);
    },
  });

  const completeProcess = async (values: any) => {
    try {
      setLoading("submit");
      // const planId = getPlanId?.Data?.filter((item: { Name: string; }) => item?.Name == 'Enterprise');

      const newData: any = {
        EnterPriseOptions: {
          Application: values?.application,
          //   Provider: values?.provider,
          Provider: "Stripe",
          PlanId: "192d0e6e-330d-4e27-a43e-d1bffe00f594",
          SubscriptionId: null,
          ProjectLimit: values?.projectLimit,
          InternalCommunicationHistoryLimit:
            values?.communicationHistoryInMonth,
          DataRetentionPeriodInMonth: values?.dataRetentionPeriodInMonth,
          TimeSheetManagement: values?.timeSheetManagement,
          ActivityLogHistoryLimit: 0,
          CalenderLimit: 0,
          StorageLimit: values?.storageInGigaByte,
          UsersLimit: values?.maxNumberofUser,
          AiAssistants: values?.aiAssistance,
          ActivatedOn: values?.activateOn,
          ExpiresOn: values?.expiresOn,
          TenantId: null,
          CreateWithOutPayment: true,
          LoggedInUserId: userId ?? null,
        },
        FirstName: values?.adminFirstname,
        LastName: values?.adminLastname,
        MiddleName: null,
        CompanyName: values?.companyName,
        Email: values?.adminEmail,
        PersonalEmail: values?.personalEmail,
        PhoneNumber: values?.phoneNumber,
        Domain: values?.subdomain,
        CompanyType: values?.companyType,
        Country: values?.country,
        Logo: null,
        Designation: null,
        Industry: 1,
        SecDomains: [],
      };
      

      const existingUserData: UserModel = {
        EnterPriseOptions: {
          Application: values?.application,
          //   Provider: values?.provider,
          Provider: "Stripe",
          PlanId: "192d0e6e-330d-4e27-a43e-d1bffe00f594",
          SubscriptionId: null,
          ProjectLimit: values?.projectLimit,
          InternalCommunicationHistoryLimit:
            values?.communicationHistoryInMonth,
          DataRetentionPeriodInMonth: values?.dataRetentionPeriodInMonth,
          TimeSheetManagement: values?.timeSheetManagement,
          ActivityLogHistoryLimit: 0,
          CalenderLimit: 0,
          StorageLimit: values?.storageInGigaByte,
          UsersLimit: values?.maxNumberofUser,
          AiAssistants: values?.aiAssistance,
          ActivatedOn: values?.activateOn,
          ExpiresOn: values?.expiresOn,
          TenantId: null,
          CreateWithOutPayment: true,
          LoggedInUserId: userId ?? null,
        },
        UserId: getPaymentDetails?.Data?.UserDetails?.Id,
        CompanyName: values?.companyName,
        Email: values?.adminEmail,
        Domain: values?.subdomain,
        CompanyType: values?.companyType,
        Country: values?.country,
        Logo: null,
        Designation: null,
        Industry: 1,
        SecDomains: [],
      };
      
      const existingData = {
        application: values?.application,
        //   Provider: values?.provider,
        provider: "Stripe",
        tenantId: getPaymentDetails?.Data?.PaymentDetails?.TenantId ?? "",
        maxNumberofUser: values?.maxNumberofUser,
        isNumberOfUserUnlimited: values?.isNumberOfUserUnlimited,
        storageInGigaByte: values?.storageInGigaByte,
        isStorageUnlimited: values?.isStorageUnlimited,
        communicationHistoryInMonth: values?.communicationHistoryInMonth,
        keepCommunicationForever: values?.keepCommunicationForever,
        projectLimit: values?.projectLimit,
        keepProjectCreationForever: values?.keepProjectCreationForever,
        dataRetentionPeriodInMonth: values?.dataRetentionPeriodInMonth,
        keepDataRetentionForever: values?.keepDataRetentionForever,
        calenderLimit: 0,
        aiAssistance: values?.aiAssistance,
        unlimitedActivityLog: values?.unlimitedActivityLog,
        timeSheetManagement: values?.timeSheetManagement,
        subscriptionId: "",
        transactionCode: "",
      };

      

      if (getPaymentDetails?.Data?.PaymentDetails?.TenantId == null) {
        if (getPaymentDetails?.Data?.PaymentDetails?.IsExistingUser) {
          const response = await createEnterpriseForExistingUser(
            existingUserData
          ).unwrap();
          if (response) {
            showToastSuccess(response?.ResponseMessage);
            setActiveRuleStep("first");
            Formik?.resetForm();
            handleReturn();
          }
        } else {
          const response = await createEnterprisePlan(newData).unwrap();
          if (response) {
            showToastSuccess(response?.ResponseMessage);
            setActiveRuleStep("first");
            Formik?.resetForm();
            handleReturn();
          }
        }
      } else {
        const response = await creatExistingEnterprisePlan(
          existingData
        ).unwrap();
        if (response) {
          showToastSuccess(response?.ResponseMessage);
          setActiveRuleStep("first");
          Formik?.resetForm();
          handleReturn();
        }
      }
    } catch (error: any) {
      if (error?.data?.errors) {
        Object.entries(error.data.errors).forEach(([key, messages]) => {
          (messages as string[]).forEach((message) => {
            showToastError(`${key}: ${message}`);
          });
        });
      } else {
        showToastError(error?.data?.ResponseMessage);
      }
    } finally {
      setLoading("");
    }
  };

  useEffect(() => {
    if (Formik?.values?.application) {
      setApplication(Formik?.values?.application);
    }
  }, [Formik?.values?.application]);

  const valid = Formik?.values?.application && companyEmail ? false : true;

  const [paymentQuery, setPaymentQuery] = useState<GetPaymentDetailsQuery>({
    companyEmail: "",
    app: "",
  });

  const {
    data: getPaymentDetails,
    error,
    isFetching,
  } = useGetEnterprisePaymentDetailsQuery(paymentQuery, {
    skip: paymentQuery?.app == "" && paymentQuery?.companyEmail == "",
  });

  function formatToDateInput(value: string): string {
    return value?.split("T")[0]; // Extract the date portion before the 'T'
  }

  function extractCompanyName(email: string) {
    const domain = email?.split("@")[1]; // Get the part after '@'
    if (!domain) return null; // Handle invalid email format
    const companyName = domain?.split(".")[0]; // Get the part before the first '.'
    return companyName.charAt(0).toUpperCase() + companyName.slice(1); // Capitalize first letter
  }

  useEffect(() => {
    Formik.setFieldValue("phoneNumber", phoneNumber);
  }, [phoneNumber]);

  useEffect(() => {
    if (getPaymentDetails) {
      const responseData = getPaymentDetails?.Data?.PaymentDetails;
      const responseUserData = getPaymentDetails?.Data?.UserDetails;
      
      
      if (responseData && responseData?.PaymentStatus == "Successful") {
        setValidatedPayment(true);
        setValidatedUser(true);
        setShowUserDetails(true);
        setPhoneNumber(responseData?.PhoneNumber);
        Formik.setFieldValue("companyName", responseData?.CompanyName || "");
        Formik.setFieldValue("amountPaid", responseData?.Amount || "");
        Formik.setFieldValue("paymentId", responseData?.PaymentId || "");
        Formik.setFieldValue(
          "transactionDate",
          formatToDateInput(responseData?.PaymentDate) || ""
        );
        Formik.setFieldValue("frequency", responseData?.Frequency || "");
        Formik.setFieldValue("currency", responseData?.Currency || "");
        Formik.setFieldValue("provider", responseData?.PaymentProvider || "");
        Formik.setFieldValue(
          "personalEmail",
          responseData?.PersonalEmail || ""
        );
        Formik.setFieldValue(
          "adminFirstname",
          responseUserData?.FirstName || ""
        );
        Formik.setFieldValue("adminLastname", responseUserData?.LastName || "");
        Formik.setFieldValue(
          "subdomain",
          extractCompanyName(responseData?.CompanyEmail) || ""
        );
      }
    } else if (error) {
      if ("data" in error) {
        const response = error.data as ExternalResponse<null>;
        if (response?.ResponseMessage) {
          showToastError(response?.ResponseMessage || "");
          setValidatedPayment(false);
          setValidatedUser(false);
          setShowUserDetails(false);
        }
      }
    }
  }, [isFetching]);

  const handleUserValidation = () => {
    if (companyEmail) {
      setPaymentQuery({
        app: Formik.values.application,
        companyEmail: companyEmail,
      });
    }
    //setValidatedUser(true);
    setShowUserDetails(true);
  };

  const {
    data: countriesData,
    error: countriesError,
    isFetching: countriesIsFetching,
  } = useGetCountriesQuery();
  const [countries, setCountries] = useState<Countries[]>();

  useEffect(() => {
    if (countriesIsFetching) {
    } else {
      if (countriesError) {
        console.error(countriesError);
      } else {
        setCountries(countriesData?.data as Countries[]);
      }
    }
  }, [countriesIsFetching, countriesError]);

  const options = countries?.map((item) => ({
    label: item?.country,
    value: item?.country,
  }));

  const industryOption = [
    "Technology",
    "Healthcare",
    "Finance",
    "Retail",
    "Education",
    "Manufacturing",
    "Transportation",
    "Hospitality",
    "Entertainment",
    "Construction",
  ];

  const firstStepValidation =
    Formik?.values?.activateOn &&
    Formik?.values?.adminEmail &&
    Formik?.values?.adminFirstname &&
    Formik?.values?.adminLastname &&
    Formik?.values?.application &&
    Formik?.values?.companyName &&
    Formik?.values?.companyType &&
    Formik?.values?.country &&
    Formik?.values?.expiresOn &&
    Formik?.values?.frequency &&
    Formik?.values?.personalEmail &&
    Formik?.values?.phoneNumber;
  // Formik?.values?.provider;

  return (
    <div className="rounded mx-auto p-3" style={{ backgroundColor: "#f6f6f6" }}>
      <div className="d-flex justify-content-between">
        {activeRuleStep == "first" ? (
          <p>Kindly fill all the fields below to proceed</p>
        ) : (
          <p className="text-center">
            <button
              onClick={() => setActiveRuleStep("first")}
              className="btn p-0"
            >
              <BiChevronLeft size={25} /> Go back
            </button>{" "}
          </p>
        )}
      </div>
      <Form onSubmit={Formik.handleSubmit}>
        {activeRuleStep == "first" && (
          <>
            <Row className="mb-1">
              {/* <Form.Group as={Col} md={Formik.values.application ? "6" : "12"} controlId="application">
                        <FloatingLabel controlId="floatingSelect" label='Choose application type' className='float-input my-3'>
                            <Form.Select
                                name="application"
                                value={Formik.values.application}
                                onChange={Formik.handleChange}
                                isValid={Formik.touched.application && !Formik.errors.application}
                                isInvalid={(Formik.touched.application && Formik.errors.application) ? true : false}
                                onBlur={Formik.handleBlur}
                                className={`border-0 w-100`}>
                                <option value=''>Choose application</option>
                                <option value='Joble'>Joble</option>
                                <option value='Echo'>Echo </option>
                                <option value='JobPays'>JobPays</option>
                                <option value='Jobfy'>Jobfy</option>
                                <option value='JobID'>JobID</option>
                                <option value='All'>All</option>
                            </Form.Select>
                        </FloatingLabel>
                    </Form.Group> */}
              <Form.Group
                hidden={Formik.values?.application ? false : true}
                as={Col}
                md="12"
                controlId="paymentId"
              >
                <FloatingLabel
                  controlId="floatingSelect"
                  label="Enter company email"
                  className="float-input my-3"
                >
                  <Form.Control
                    name="companyEmail"
                    autoComplete="none"
                    placeholder="Enter company email"
                    value={companyEmail}
                    onChange={(e) => {
                      Formik.setFieldValue("adminEmail", e.target.value);
                    }}
                    isValid={companyEmail && validatedPayment}
                    onBlur={() => handleUserValidation()}
                    className={`border-0 w-100`}
                  />
                </FloatingLabel>
              </Form.Group>
            </Row>
            {isFetching && (
              <div className="p-5 text-center">
                <Spinner />
              </div>
            )}
            {Formik.values?.application && (
              <div>
                <Row className="mb-1">
                  <Form.Group as={Col} md="12" controlId="frequency">
                    <FloatingLabel
                      controlId="floatingSelect"
                      label="Select a frequency"
                      className="float-input my-3"
                    >
                      <Form.Select
                        name="frequency"
                        value={Formik.values.frequency}
                        onChange={Formik.handleChange}
                        isValid={
                          getPaymentDetails?.Data?.PaymentDetails?.PaymentStatus
                            ? true
                            : false
                        }
                        isInvalid={
                          Formik.touched.frequency && Formik.errors.frequency
                            ? true
                            : false
                        }
                        onBlur={Formik.handleBlur}
                        className={`border-0 w-100`}
                      >
                        <option value="">Select an option</option>
                        <option value="Yearly">Yearly</option>
                        <option value="Monthly">Monthly</option>
                      </Form.Select>
                    </FloatingLabel>
                  </Form.Group>
                  {/* <Form.Group as={Col} md="6" controlId="provider">
                    <FloatingLabel
                      controlId="floatingSelect"
                      label="Select payment provider"
                      className="float-input my-3"
                    >
                      <Form.Select
                        name="provider"
                        value={Formik.values.provider}
                        onChange={Formik.handleChange}
                        isValid={
                          getPaymentDetails?.Data?.PaymentDetails?.PaymentStatus
                            ? true
                            : false
                        }
                        isInvalid={
                          Formik.touched.provider && Formik.errors.provider
                            ? true
                            : false
                        }
                        onBlur={Formik.handleBlur}
                        className={`border-0 w-100`}
                      >
                        <option value="">Select an option</option>
                        <option value="Mollie">Mollie</option>
                        <option value="Stripe">Stripe</option>
                        <option value="Others">Others</option>
                      </Form.Select>
                    </FloatingLabel>
                  </Form.Group> */}
                </Row>

                <Row className="mb-1">
                  <Form.Group as={Col} md="6" controlId="companyName">
                    <FloatingLabel
                      controlId="floatingSelect"
                      label="Enter company name"
                      className="float-input my-3"
                    >
                      <Form.Control
                        type="text"
                        name="companyName"
                        disabled={validatedUser}
                        placeholder="Enter company name"
                        value={Formik.values.companyName}
                        onChange={Formik.handleChange}
                        isValid={
                          getPaymentDetails?.Data?.PaymentDetails?.PaymentStatus
                            ? true
                            : false
                        }
                        isInvalid={
                          Formik.touched.companyName &&
                          Formik.errors.companyName
                            ? true
                            : false
                        }
                        onBlur={Formik.handleBlur}
                        className={`border-0 w-100`}
                      />
                    </FloatingLabel>
                  </Form.Group>
                  <Form.Group as={Col} md="6" controlId="subdomain">
                    <FloatingLabel
                      controlId="floatingSelect"
                      label="Enter subdomain"
                      className="float-input my-3"
                    >
                      <Form.Control
                        type="text"
                        name="subdomain"
                        placeholder="Enter subdomain"
                        value={Formik.values.subdomain}
                        onChange={Formik.handleChange}
                        isValid={
                          (getPaymentDetails?.Data?.PaymentDetails
                            ?.PaymentStatus
                            ? true
                            : false) ||
                          (Formik.touched.subdomain && !Formik.errors.subdomain)
                        }
                        isInvalid={
                          Formik.touched.subdomain && Formik.errors.subdomain
                            ? true
                            : false
                        }
                        onBlur={Formik.handleBlur}
                        className={`border-0 w-100`}
                      />
                    </FloatingLabel>
                  </Form.Group>
                  {/* <Form.Group as={Col} md="6" controlId="adminEmail">
                            <FloatingLabel controlId="floatingSelect" label='Enter admin email address' className='float-input my-3'>
                                <Form.Control
                                    type="text"
                                    name="adminEmail"
                                    disabled={getPaymentDetails?.Data?.UserDetails !== null}
                                    placeholder='Enter admin email'
                                    value={Formik.values.adminEmail}
                                    onChange={Formik.handleChange}
                                    isValid={Formik.touched.adminEmail && !Formik.errors.adminEmail}
                                    isInvalid={(Formik.touched.adminEmail && Formik.errors.adminEmail) ? true : false}
                                    onBlur={Formik.handleBlur}
                                    className={`border-0 w-100`} />
                            </FloatingLabel>
                        </Form.Group> */}
                  <Form.Group as={Col} md="6" controlId="adminFirstname">
                    <FloatingLabel
                      controlId="floatingSelect"
                      label="Enter admin firstname"
                      className="float-input my-3"
                    >
                      <Form.Control
                        type="text"
                        name="adminFirstname"
                        disabled={
                          getPaymentDetails?.Data?.UserDetails?.FirstName
                            ? true
                            : false
                        }
                        placeholder="Enter admin firstname"
                        value={Formik.values.adminFirstname}
                        onChange={Formik.handleChange}
                        isValid={
                          (getPaymentDetails?.Data?.PaymentDetails
                            ?.PaymentStatus && Formik.values.adminFirstname
                            ? true
                            : false) ||
                          (Formik.touched.adminFirstname &&
                            !Formik.errors.adminFirstname)
                        }
                        isInvalid={
                          Formik.touched.adminFirstname &&
                          Formik.errors.adminFirstname
                            ? true
                            : false
                        }
                        onBlur={Formik.handleBlur}
                        className={`border-0 w-100`}
                      />
                    </FloatingLabel>
                  </Form.Group>
                  <Form.Group as={Col} md="6" controlId="adminLastname">
                    <FloatingLabel
                      controlId="floatingSelect"
                      label="Enter admin lastname"
                      className="float-input my-3"
                    >
                      <Form.Control
                        type="text"
                        name="adminLastname"
                        disabled={
                          getPaymentDetails?.Data?.UserDetails?.LastName
                            ? true
                            : false
                        }
                        placeholder="Enter admin lastname"
                        value={Formik.values.adminLastname}
                        onChange={Formik.handleChange}
                        isValid={
                          (getPaymentDetails?.Data?.PaymentDetails
                            ?.PaymentStatus && Formik.values.adminLastname
                            ? true
                            : false) ||
                          (Formik.touched.adminLastname &&
                            !Formik.errors.adminLastname)
                        }
                        isInvalid={
                          Formik.touched.adminLastname &&
                          Formik.errors.adminLastname
                            ? true
                            : false
                        }
                        onBlur={Formik.handleBlur}
                        className={`border-0 w-100`}
                      />
                    </FloatingLabel>
                  </Form.Group>
                  <Form.Group as={Col} md="6" controlId="personalEmail">
                    <FloatingLabel
                      controlId="floatingSelect"
                      label="Enter personal email address"
                      className="float-input my-3"
                    >
                      <Form.Control
                        type="email"
                        name="personalEmail"
                        placeholder="Enter personal email address"
                        disabled={
                          getPaymentDetails?.Data?.UserDetails?.Email
                            ? true
                            : false
                        }
                        value={Formik.values.personalEmail}
                        onChange={Formik.handleChange}
                        isValid={
                          (getPaymentDetails?.Data?.PaymentDetails
                            ?.PaymentStatus && Formik.values.personalEmail
                            ? true
                            : false) ||
                          (Formik.touched.personalEmail &&
                            !Formik.errors.personalEmail)
                        }
                        isInvalid={
                          Formik.touched.personalEmail &&
                          Formik.errors.personalEmail
                            ? true
                            : false
                        }
                        onBlur={(e) => {
                          Formik.handleBlur(e);
                          handleUserValidation();
                        }}
                        className={`border-0 w-100`}
                      />
                    </FloatingLabel>
                  </Form.Group>
                  <Form.Group
                    as={Col}
                    md="6"
                    controlId="phoneNumber"
                    className="d-flex"
                  >
                    <PhoneInput
                      placeholder="Enter admin phone number"
                      international
                      disabled={
                        getPaymentDetails?.Data?.UserDetails?.PhoneNumber
                          ? true
                          : false
                      }
                      value={phoneNumber}
                      defaultCountry="US"
                      onChange={(phone) => setPhoneNumber(phone)}
                      inputProps={{ name: "phoneNumber", required: true }}
                      onBlur={() => {
                        setPhoneValidation(true);
                        handleUserValidation();
                      }}
                      countryCallingCodeEditable={false}
                      className="d-flex justify-content-between w-100 my-3"
                    />
                    {/* {phoneNumber && <div className='text-end px-2 my-auto' style={{ marginLeft: '-40px' }}>{phoneValidation ? <BsCheckLg size={20} color='green' /> : <AiOutlineInfoCircle size={18} color='red' style={{ transform: 'rotate(180deg)' }} />}</div>} */}
                  </Form.Group>
                </Row>
                <Row className="mb-1">
                  <Form.Group as={Col} md="6" controlId="companyType">
                    <FloatingLabel
                      controlId="floatingSelect"
                      label="Select company type"
                      className="float-input my-3"
                    >
                      <Form.Select
                        name="companyType"
                        value={Formik.values.companyType}
                        onChange={Formik.handleChange}
                        isValid={
                          (getPaymentDetails?.Data?.PaymentDetails
                            ?.PaymentStatus && Formik.values.companyType
                            ? true
                            : false) ||
                          (Formik.touched.companyType &&
                            !Formik.errors.companyType)
                        }
                        isInvalid={
                          Formik.touched.companyType &&
                          Formik.errors.companyType
                            ? true
                            : false
                        }
                        onBlur={Formik.handleBlur}
                        className={`border-0 w-100`}
                      >
                        <option value="">Select an option</option>
                        {industryOption?.map((list, key) => (
                          <option key={key} value={list}>
                            {list}
                          </option>
                        ))}
                      </Form.Select>
                    </FloatingLabel>
                  </Form.Group>
                  <Form.Group as={Col} md="6" controlId="activateOn">
                    <FloatingLabel
                      controlId="floatingSelect"
                      label="Enter subscription commencement"
                      className="float-input my-3"
                    >
                      <Form.Control
                        type="date"
                        name="activateOn"
                        value={Formik.values.activateOn}
                        onChange={(e) => {
                          const startDate = e.target.value;
                          Formik.setFieldValue("activateOn", startDate);

                          // Automatically calculate expiry date
                          if (startDate) {
                            const start = new Date(startDate);

                            if (Formik?.values?.frequency == "Monthly") {
                              const expiryDate = new Date(
                                start.setMonth(start.getMonth() + 1)
                              )
                                .toISOString()
                                ?.split("T")[0];
                              Formik.setFieldValue("expiresOn", expiryDate);
                            }
                            if (Formik?.values?.frequency == "Yearly") {
                              const expiryDate = new Date(
                                start.setFullYear(start.getFullYear() + 1)
                              )
                                .toISOString()
                                ?.split("T")[0];
                              Formik.setFieldValue("expiresOn", expiryDate);
                            }
                          }
                        }}
                        isValid={
                          Formik.touched.activateOn && !Formik.errors.activateOn
                        }
                        isInvalid={
                          Formik.touched.activateOn && Formik.errors.activateOn
                            ? true
                            : false
                        }
                        onBlur={Formik.handleBlur}
                        className={`border-0 w-100`}
                      />
                    </FloatingLabel>
                  </Form.Group>
                </Row>
                <Row className="mb-1">
                  <Form.Group as={Col} md="6" controlId="expiresOn">
                    <FloatingLabel
                      controlId="floatingSelect"
                      label="Enter subscription expiry date"
                      className="float-input my-3"
                    >
                      <Form.Control
                        type="date"
                        name="expiresOn"
                        disabled
                        value={Formik.values.expiresOn}
                        onChange={Formik.handleChange}
                        isValid={
                          Formik.touched.expiresOn && !Formik.errors.expiresOn
                        }
                        isInvalid={
                          Formik.touched.expiresOn && Formik.errors.expiresOn
                            ? true
                            : false
                        }
                        onBlur={Formik.handleBlur}
                        className={`border-0 w-100`}
                      />
                    </FloatingLabel>
                  </Form.Group>
                  <Form.Group
                    as={Col}
                    md="6"
                    controlId="country"
                    className="d-flex"
                  >
                    <FloatingLabel
                      controlId="floatingSelect"
                      label="Choose country"
                      className="float-input my-3"
                    >
                      <Form.Select
                        name="country"
                        value={Formik.values.country}
                        onChange={Formik.handleChange}
                        isValid={
                          Formik.touched.country && !Formik.errors.country
                        }
                        onBlur={Formik.handleBlur}
                        aria-label="Floating label select example"
                        className={`border-0 w-100`}
                      >
                        <option value="">Choose country</option>
                        {countries &&
                          options?.map((item, key) => (
                            <option key={key} value={item.value}>
                              {item?.label}
                            </option>
                          ))}
                      </Form.Select>
                    </FloatingLabel>
                  </Form.Group>
                </Row>
                <button
                  type="button"
                  disabled={!firstStepValidation}
                  onClick={() => setActiveRuleStep("second")}
                  className="btn-primary w-100 rounded-5"
                >
                  Proceed
                </button>
              </div>
            )}
          </>
        )}

        {activeRuleStep == "second" && (
          <div>
            <div className="pt-2">
              <p>
                <b>Set Preferences</b>
              </p>
              <Row className="my-2 justify-content-between">
                <Form.Group
                  as={Col}
                  md="8"
                  controlId="maxNumberofUser"
                  className="d-flex gap-4 justify-content-between"
                >
                  <span className="align-top pt-2">Max number of users</span>
                  <NumericFormat
                    suffix={""}
                    className="primary-text fs-5 fw-bold px-3 border-0 rounded bg-white py-0 my-0"
                    name="maxNumberOfUser"
                    value={Formik.values.maxNumberofUser}
                    //onChange={Formik.handleChange}
                    onValueChange={(values) => {
                      const { value } = values;
                      Formik.setFieldValue("maxNumberofUser", parseInt(value));
                      if (parseInt(value) > 0) {
                        Formik.setFieldValue("isNumberOfUserUnlimited", false);
                      }
                    }}
                    onBlur={(e) => {
                      Formik.handleBlur(e);
                      handleUserValidation();
                    }}
                    style={{ width: "130px" }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="4" controlId="isNumberOfUserUnlimited">
                  <Form.Check
                    label="Unlimited"
                    id="Subscription Summary"
                    className="dark-text my-2 float-end"
                    checked={Formik.values.isNumberOfUserUnlimited}
                    name="isNumberOfUserUnlimited"
                    onChange={(e) => {
                      const isChecked = e.target.checked;
                      Formik.setFieldValue(
                        "isNumberOfUserUnlimited",
                        isChecked
                      );
                      if (isChecked) {
                        Formik.setFieldValue("maxNumberofUser", 0);
                      }
                    }}
                    onBlur={Formik.handleBlur}
                  />
                </Form.Group>
              </Row>
            </div>
            <div className="pt-3">
              <p>
                <b>Storage and Communication</b>
              </p>
              <Row className="my-2">
                <Form.Group
                  as={Col}
                  md="8"
                  controlId="storageInGigaByte"
                  className="d-flex gap-4 justify-content-between"
                >
                  <span className="align-top pt-2">Storage</span>
                  <NumericFormat
                    suffix={" gig"}
                    className="primary-text fs-5 fw-bold px-3 border-0 rounded bg-white py-0 my-0"
                    name="storageInGigaByte"
                    value={Formik.values.storageInGigaByte}
                    //onChange={Formik.handleChange}
                    onValueChange={(values) => {
                      const { value } = values;
                      Formik.setFieldValue(
                        "storageInGigaByte",
                        parseInt(value)
                      );
                      if (parseInt(value) > 0) {
                        Formik.setFieldValue("isStorageUnlimited", false);
                      }
                    }}
                    onBlur={Formik.handleBlur}
                    style={{ width: "130px" }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="4" controlId="isStorageUnlimited">
                  <Form.Check
                    label="Unlimited"
                    id="Unlimited Storage"
                    className="dark-text my-2 float-end"
                    checked={Formik.values.isStorageUnlimited}
                    name="isStorageUnlimited"
                    onChange={(e) => {
                      const isChecked = e.target.checked;
                      Formik.setFieldValue("isStorageUnlimited", isChecked);
                      if (isChecked) {
                        Formik.setFieldValue("storageInGigaByte", 0);
                      }
                    }}
                    onBlur={Formik.handleBlur}
                  />
                </Form.Group>
              </Row>

              <Row className="my-2">
                <Form.Group
                  as={Col}
                  md="8"
                  controlId="communicationHistoryInMonth"
                  className="d-flex gap-4 justify-content-between"
                >
                  <span className="align-top pt-2">Communication History</span>
                  <NumericFormat
                    suffix={" months"}
                    className="primary-text fs-5 fw-bold px-3 border-0 rounded bg-white py-0 my-0"
                    name="communicationHistoryInMonth"
                    value={Formik.values.communicationHistoryInMonth}
                    //onChange={Formik.handleChange}
                    onValueChange={(values) => {
                      const { value } = values;
                      Formik.setFieldValue(
                        "communicationHistoryInMonth",
                        parseInt(value)
                      );
                      if (parseInt(value) > 0) {
                        Formik.setFieldValue("keepCommunicationForever", false);
                      }
                    }}
                    onBlur={Formik.handleBlur}
                    style={{ width: "130px" }}
                  />
                </Form.Group>
                <Form.Group
                  as={Col}
                  md="4"
                  controlId="keepCommunicationForever"
                >
                  <Form.Check
                    label="Keep Forever"
                    id="Keep Communication Forever"
                    className="dark-text my-2 float-end"
                    checked={Formik.values.keepCommunicationForever}
                    name="keepCommunicationForever"
                    onChange={(e) => {
                      const isChecked = e.target.checked;
                      Formik.setFieldValue(
                        "keepCommunicationForever",
                        isChecked
                      );
                      if (isChecked) {
                        Formik.setFieldValue("communicationHistoryInMonth", 0);
                      }
                    }}
                    onBlur={Formik.handleBlur}
                  />
                </Form.Group>
              </Row>
            </div>
            <div className="pt-3">
              <p>
                <b>Timesheet and Project</b>
              </p>
              <Row className="my-2">
                <Form.Group
                  as={Col}
                  md="8"
                  controlId="projectLimit"
                  className="d-flex gap-4 justify-content-between"
                >
                  <span className="align-top pt-2">Project Creation</span>
                  <NumericFormat
                    suffix={""}
                    className="primary-text fs-5 fw-bold px-3 border-0 rounded bg-white py-0 my-0"
                    name="projectLimit"
                    value={Formik.values.projectLimit}
                    //onChange={Formik.handleChange}
                    onValueChange={(values) => {
                      const { value } = values;
                      Formik.setFieldValue("projectLimit", parseInt(value));
                      if (parseInt(value) > 0) {
                        Formik.setFieldValue(
                          "keepProjectCreationForever",
                          false
                        );
                      }
                    }}
                    onBlur={Formik.handleBlur}
                    style={{ width: "130px" }}
                  />
                </Form.Group>
                <Form.Group
                  as={Col}
                  md="4"
                  controlId="keepProjectCreationForever"
                >
                  <Form.Check
                    label="Keep Forever"
                    id="Keep Project Forever"
                    className="dark-text my-2 float-end"
                    checked={Formik.values.keepProjectCreationForever}
                    name="keepProjectCreationForever"
                    onChange={(e) => {
                      const isChecked = e.target.checked;
                      Formik.setFieldValue(
                        "keepProjectCreationForever",
                        isChecked
                      );
                      if (isChecked) {
                        Formik.setFieldValue("projectLimit", 0);
                      }
                    }}
                    onBlur={Formik.handleBlur}
                  />
                </Form.Group>
              </Row>
              <Row className="my-2">
                <Form.Group as={Col} md="12" controlId="timeSheetManagement">
                  <Form.Check
                    label="Timesheet Management"
                    id="Timesheet Management"
                    className="dark-text my-2"
                    checked={Formik.values.timeSheetManagement}
                    name="timeSheetManagement"
                    onChange={Formik.handleChange}
                    onBlur={Formik.handleBlur}
                  />
                </Form.Group>
              </Row>
            </div>

            <div className="pt-3">
              <p>
                <b>Data Retention, AI and Activity Log</b>
              </p>
              <Row className="my-2">
                <Form.Group
                  as={Col}
                  md="8"
                  controlId="dataRetentionPeriodInMonth"
                  className="d-flex gap-4 justify-content-between"
                >
                  <span className="align-top pt-2">Data Retention Period</span>
                  <NumericFormat
                    suffix={" months"}
                    className="primary-text fs-5 fw-bold px-3 border-0 rounded bg-white py-0 my-0"
                    name="dataRetentionPeriodInMonth"
                    value={Formik.values.dataRetentionPeriodInMonth}
                    //onChange={Formik.handleChange}
                    onValueChange={(values) => {
                      const { value } = values;
                      Formik.setFieldValue(
                        "dataRetentionPeriodInMonth",
                        parseInt(value)
                      );
                      if (parseInt(value) > 0) {
                        Formik.setFieldValue("keepDataRetentionForever", false);
                      }
                    }}
                    onBlur={Formik.handleBlur}
                    style={{ width: "130px" }}
                  />
                </Form.Group>
                <Form.Group
                  as={Col}
                  md="4"
                  controlId="keepDataRetentionForever "
                >
                  <Form.Check
                    label="Keep Forever"
                    id="Keep Data Forever"
                    className="dark-text my-2 float-end"
                    checked={Formik.values.keepDataRetentionForever}
                    name="keepDataRetentionForever"
                    onChange={(e) => {
                      const isChecked = e.target.checked;
                      Formik.setFieldValue(
                        "keepDataRetentionForever",
                        isChecked
                      );
                      if (isChecked) {
                        Formik.setFieldValue("dataRetentionPeriodInMonth", 0);
                      }
                    }}
                    onBlur={Formik.handleBlur}
                  />
                </Form.Group>
              </Row>
              <Row className="my-2">
                <Form.Group as={Col} md="12" controlId="aiAssistance">
                  <Form.Check
                    label="AI Assistant"
                    id="AI Assistant"
                    className="dark-text my-2"
                    checked={Formik.values.aiAssistance}
                    name="aiAssistance"
                    onChange={Formik.handleChange}
                    onBlur={Formik.handleBlur}
                  />
                </Form.Group>
              </Row>
              <Row className="my-2">
                <Form.Group as={Col} md="12" controlId="unlimitedActivityLog">
                  <Form.Check
                    label="Unlimited History Activity Log"
                    id="Unlimited History Activity Log"
                    className="dark-text my-2"
                    checked={Formik.values.unlimitedActivityLog}
                    name="unlimitedActivityLog"
                    onChange={Formik.handleChange}
                    onBlur={Formik.handleBlur}
                  />
                </Form.Group>
              </Row>
            </div>
            <button
              type="submit"
              className="btn-primary w-100 rounded-5 my-3"
              onClick={() => completeProcess(Formik.values)}
            >
              Activate Plan {loading === "submit" && <Spinner size="sm" />}
            </button>
          </div>
        )}
      </Form>
      <GeneratePayment
        showModal={show}
        setShowModal={(value) => setShow(value)}
      />
    </div>
  );
};

export default CreateEnterpriseWithoutPayment;

